/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Use_Web_PageInputs */

const en_dashboard_use_web_page = /** @type {(inputs: Dashboard_Use_Web_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use web page`)
};

const es_dashboard_use_web_page = /** @type {(inputs: Dashboard_Use_Web_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar página web`)
};

/**
* | output |
* | --- |
* | "Use web page" |
*
* @param {Dashboard_Use_Web_PageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dashboard_use_web_page = /** @type {((inputs?: Dashboard_Use_Web_PageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Use_Web_PageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dashboard_use_web_page(inputs)
	return en_dashboard_use_web_page(inputs)
});